export const stats = [
  { value: '12', label: 'Volúmenes Completos' },
  { value: '+1.500', label: 'Docentes' },
  { value: '5', label: 'Bonos Exclusivos' },
  { value: '100%', label: 'Digital y Descargable' },
]

export const differenceStats = [
  { value: '12', label: 'Volúmenes por Niveles de Progresión' },
  { value: '5', label: 'Bonos Complementarios' },
  { value: '100%', label: 'Listo para Descargar' },
]

export const beforeItems = [
  'Horas buscando y preparando materiales para cada clase',
  'Actividades sueltas sin una progresión clara',
  'Fichas de diferentes sitios que no siguen la misma estructura',
  'Tener que crear evaluaciones y ejercicios desde cero',
  'No saber qué recurso utilizar con cada nivel',
  'Llegar al domingo por la noche y todavía no tener lista la semana',
]

export const afterItems = [
  '5 minutos para revisar el material y estar listo',
  'Actividades visuales y listas para utilizar',
  '12 volúmenes organizados por progresión',
  'Fichas, práctica y recursos imprimibles',
  'Evaluaciones y materiales docentes preparados',
  'Más tiempo para enseñar y menos tiempo para planificar',
]

export const recognizeItems = [
  {
    emoji: '😰',
    text: 'Llegas a una clase sin tener completamente claro qué actividad vas a utilizar',
  },
  {
    emoji: '⏱️',
    text: 'Pierdes gran parte del domingo preparando algo que debería llevarte minutos',
  },
  {
    emoji: '🤷',
    text: 'Buscas durante horas fichas y actividades que realmente tengan buena calidad',
  },
  {
    emoji: '📋',
    text: 'No tienes evaluaciones y recursos organizados para acompañar la progresión de tus alumnos',
  },
  {
    emoji: '😴',
    text: 'Tus alumnos pierden interés porque terminas utilizando siempre los mismos tipos de actividades',
  },
  {
    emoji: '🌙',
    text: 'Es domingo por la noche y todavía estás preparando las clases del lunes',
  },
]

export const packItems = [
  {
    emoji: '📚',
    title: '12 Volúmenes por Niveles de Progresión',
    text: 'Una colección completa diseñada para acompañar el aprendizaje del inglés desde los primeros pasos hasta una comunicación mucho más segura y autónoma.',
  },
  {
    emoji: '✏️',
    title: 'Materiales Listos para Usar',
    text: 'Recursos preparados para que puedas abrir el volumen correspondiente, elegir lo que necesitas y llevarlo directamente a tu clase.',
  },
  {
    emoji: '📝',
    title: 'Actividades y Fichas Imprimibles',
    text: 'Material práctico para trabajar vocabulario, comprensión, expresión y diferentes habilidades del idioma.',
  },
  {
    emoji: '🗣️',
    title: 'Práctica y Actividades para el Aula',
    text: 'Recursos pensados para conseguir clases más dinámicas, participativas y fáciles de ejecutar.',
  },
  {
    emoji: '📊',
    title: 'Evaluaciones y Recursos Docentes',
    text: 'Material para comprobar el progreso de tus alumnos sin tener que crear cada evaluación desde cero.',
  },
  {
    emoji: '🔑',
    title: 'Recursos Organizados por Progresión',
    text: 'Encuentra más rápido el material adecuado según el nivel y las necesidades de tus alumnos.',
  },
]

export const samplePages = [
  {
    level: 'A1',
    caption: 'Nivel A1',
    title: 'Unit 03 · Create Your English Profile',
    text: 'Datos personales guiados, entrevistas en parejas y una autoevaluación rápida.',
    image:
      'https://cdn.magicpatterns.com/uploads/az1P57YVHgfMfPNetvzwRH/Captura-de-pantalla-2026-09-24-a-las-3.18.39_p._m..webp',
  },
  {
    level: 'A2',
    caption: 'Nivel A2',
    title: 'A Day at Work / Study',
    text: 'Perfiles de la vida real, preguntas de comprensión y una misión oral.',
    image:
      'https://cdn.magicpatterns.com/uploads/5QDTqg5J4QCd3wfX3HkqX2/Captura-de-pantalla-2026-09-24-a-las-3.19.49_p._m..webp',
  },
  {
    level: 'B1',
    caption: 'Nivel B1',
    title: 'What Happened Next? · Unit 02',
    text: 'Narración con imágenes, conectores y un desafío de 60 segundos.',
    image:
      'https://cdn.magicpatterns.com/uploads/ux1eEzzoqdmrW8M3TEuPia/Captura-de-pantalla-2026-09-24-a-las-3.20.44_p._m._(1).webp',
  },
  {
    level: 'B2',
    caption: 'Nivel B2',
    title: 'The Future of Daily Life · Unit 06',
    text: 'Lenguaje para hacer predicciones, preguntas de debate y un desafío de argumentación.',
    image:
      'https://cdn.magicpatterns.com/uploads/1uNsQ4EHfrw8hsMTSzyKCh/Captura-de-pantalla-2026-09-24-a-las-3.21.37_p._m..webp',
  },
  {
    level: 'C1',
    caption: 'Nivel C1',
    title: 'C1 Grammar at a Glance',
    text: 'Ocho estructuras avanzadas organizadas visualmente en una sola página.',
    image:
      'https://cdn.magicpatterns.com/uploads/1jbfrnmAj1ojs4fnncbWYW/Captura-de-pantalla-2026-09-24-a-las-3.26.53_p._m..webp',
  },
  {
    level: 'Nivelación',
    caption: 'Prueba de Nivel',
    title: 'Speaking Placement Check',
    text: 'Una rúbrica lista para ubicar a cada alumno en el nivel adecuado.',
    image:
      'https://cdn.magicpatterns.com/uploads/nhSnk7Brt4ZdeqZiQnQFBm/Captura-de-pantalla-2026-09-24-a-las-3.43.13_p._m..webp',
  },
]

export type Volume = {
  number: number
  title: string
  text: string
  /** Tailwind classes for the volume's cover color (matches the printed covers). */
  coverClass: string
}

export const volumes: Volume[] = [
  {
    number: 1,
    title: 'English First Steps',
    text: 'Los primeros pasos para comenzar a construir vocabulario, comprensión y confianza con el idioma.',
    coverClass: 'bg-blue-700 text-white',
  },
  {
    number: 2,
    title: 'English Adventure',
    text: 'Actividades progresivas para continuar desarrollando las bases del inglés.',
    coverClass: 'bg-green-700 text-white',
  },
  {
    number: 3,
    title: 'Explorer English',
    text: 'Nuevos contextos, vocabulario y actividades para seguir avanzando en el aprendizaje.',
    coverClass: 'bg-orange-500 text-white',
  },
  {
    number: 4,
    title: 'City English',
    text: 'Inglés aplicado a situaciones, lugares y contextos cotidianos.',
    coverClass: 'bg-red-600 text-white',
  },
  {
    number: 5,
    title: 'Global English',
    text: 'Más vocabulario, comprensión y expresión a través de nuevos temas y situaciones.',
    coverClass: 'bg-purple-700 text-white',
  },
  {
    number: 6,
    title: 'Future English',
    text: 'Recursos para continuar desarrollando confianza y autonomía con el idioma.',
    coverClass: 'bg-cyan-700 text-white',
  },
  {
    number: 7,
    title: 'Teen English Foundations',
    text: 'Una estructura pensada para desarrollar las bases del inglés en estudiantes adolescentes.',
    coverClass: 'bg-pink-600 text-white',
  },
  {
    number: 8,
    title: 'Real Life English',
    text: 'Actividades para utilizar el inglés en situaciones prácticas y cercanas a la vida real.',
    coverClass: 'bg-blue-900 text-white',
  },
  {
    number: 9,
    title: 'Global Teen English',
    text: 'Contenidos para ampliar vocabulario, comprensión y expresión en estudiantes adolescentes.',
    coverClass: 'bg-violet-700 text-white',
  },
  {
    number: 10,
    title: 'English for Expression',
    text: 'Recursos para desarrollar una expresión cada vez más clara, activa y segura.',
    coverClass: 'bg-yellow-400 text-stone-900',
  },
  {
    number: 11,
    title: 'Academic & Practical English',
    text: 'Inglés académico y práctico para desarrollar una mayor autonomía con el idioma.',
    coverClass: 'bg-indigo-800 text-white',
  },
  {
    number: 12,
    title: 'Confident English Mastery',
    text: 'Consolida lo aprendido y ayuda a tus alumnos a comunicarse con mayor seguridad y confianza.',
    coverClass: 'bg-purple-900 text-white',
  },
]

export const instantItems = [
  'Los 12 volúmenes digitales completos',
  'Materiales organizados por niveles de progresión',
  'Actividades y fichas listas para usar',
  'Recursos imprimibles para tus clases',
  'Material de práctica y refuerzo',
  'Evaluaciones y recursos docentes',
  'Acceso a los 5 bonos exclusivos',
]

export const bonuses = [
  {
    title: 'THE FLASHCARD MASTER-PACK™',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/3f84dfdd-ea7a-42f8-b113-9dbcbbc7ce9f.jpg',
    text: 'Flashcards listas para imprimir y utilizar en actividades de vocabulario, práctica y repaso.',
  },
  {
    title: 'WARM-UPS & ICEBREAKERS™',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/1ca16e9c-c126-4e2b-b1d4-c0856db9bfb9.jpg',
    text: 'Actividades preparadas para comenzar tus clases, romper el hielo y conseguir participación desde los primeros minutos.',
  },
  {
    title: "THE TEACHER'S CLASSROOM TOOLKIT™",
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/46449a4a-735f-4db7-92c2-e3b350e0849e.jpg',
    text: 'Herramientas y recursos complementarios para organizar y desarrollar tus clases con mayor facilidad.',
  },
  {
    title: 'ASSESSMENT POWER-PACK™',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/f68e546a-df95-488a-997e-548903bb69ab.jpg',
    text: 'Recursos de evaluación preparados para comprobar el progreso de tus alumnos sin empezar desde cero.',
  },
  {
    title: 'DIGITAL HOMEWORK HUB™',
    cover:
      'https://cdn.magicpatterns.com/patterns/generated-images/6b5847b2-6778-4852-9ed8-c4a651422904.jpg',
    text: 'Material complementario para tareas, práctica y refuerzo fuera del aula.',
  },
]

export const offerRows = [
  { label: 'Pack INGLÉS LISTO™ — 12 Volúmenes Digitales', value: 'US$97' },
  { label: '5 Bonos Exclusivos', value: 'INCLUIDOS GRATIS' },
]

export type Testimonial = {
  quote: string
  name: string
  location: string
}

// Agrega aquí testimonios reales de INGLÉS LISTO™.
export const testimonials: Testimonial[] = []

export const faqs = [
  {
    q: '¿Cómo recibo el material?',
    a: 'Después de completar tu compra tendrás acceso digital a INGLÉS LISTO™ para descargar tus materiales.',
  },
  {
    q: '¿Funciona si soy docente principiante?',
    a: 'Sí. El sistema está pensado para ayudarte a tener una estructura y materiales organizados, reduciendo la necesidad de preparar cada recurso desde cero.',
  },
  {
    q: '¿Qué niveles incluye?',
    a: 'INGLÉS LISTO™ está compuesto por 12 volúmenes organizados por niveles de progresión, desde los primeros pasos hasta contenidos de mayor autonomía y dominio del idioma.',
  },
  {
    q: '¿Los 5 bonos están incluidos en el precio?',
    a: 'Sí. Los 5 bonos están incluidos dentro de esta oferta.',
  },
  {
    q: '¿Es un producto físico?',
    a: 'No. INGLÉS LISTO™ es un producto 100% digital. No recibirás libros físicos por correo.',
  },
  {
    q: '¿Puedo imprimir los materiales?',
    a: 'Sí. Los recursos imprimibles están preparados para que puedas utilizarlos en tus clases cuando los necesites.',
  },
  {
    q: '¿Tengo que pagar todos los meses?',
    a: 'No.\nUS$16,99 es un único pago.\nSin mensualidades. Sin suscripciones.',
  },
]
